import { CREATE_FACILITY_TEST_COST } from "constants/ActionTypes";

const INITIAL_STATE = {
  data: [],
  loading: false,
  facilityTestCostList: [],
  approveResultList: [],
  enteredResultList: [],
};

const BillingReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CREATE_FACILITY_TEST_COST: {
      let updatedList = state.facilityTestCostList;
      updatedList = [action.payload, ...updatedList];

      return {
        ...state,
        facilityTestCostList: updatedList,
      };
    }
    // case APPROVE_GENERAL_ORDER_RESULT: {
    //   let updatedList = state.approveResultList;
    //   updatedList = [action.payload, ...updatedList];
    //
    //   return {
    //     ...state,
    //     approveResultList: updatedList,
    //   };
    // }
    // case FETCH_ENTERED_RESULT_TEST_TYPE: {
    //   return {
    //     ...state,
    //     enteredResultList: action.payload,
    //   };
    // }

    default:
      return state;
  }
};

export default BillingReducer;
